import { Component, Input, OnInit } from '@angular/core';

import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'add-person',
  templateUrl: './create-group.component.html',
  styleUrls: ['./create-group.component.scss']
})
export class CreateGroupComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/pages/companies/create-group-modal/create-group.component.ts